module.exports = __webpack_public_path__ + "2adffdae94903a37d6abce940460a897.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/images_en/home-bg-2.jpg
// module id = 1121
// module chunks = 0